import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { Alert, Button, Card, Image } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { Navigate, useNavigate } from 'react-router-dom';
import { ExamService } from '../../../../Services/examServices';

const StudentInfo = () => {

    const navigate = useNavigate();

    const [userInfo, setUserInfo] = useState<any>();



    const getUserInfoExams = async () => {
        await ExamService.getUserInfoWithExams().then((res) => {
            if (res.status === 200) {
                setUserInfo(res.data.data);
                toast.success("Data fetched successfully");

            }
        }).catch((err) => {
            console.log(err);

        })
    }

    function createDateFormat(date: Date) {
        return moment(date).format("Do MMM YYYY");
    }



    useEffect(() => {
        getUserInfoExams();
    }, [])

 return (
    <>
        <Card
            className="mt-4 mb-4 shadow-sm"
            style={{ maxWidth: "75rem", margin: "0 auto", borderRadius: "12px" }}
        >
            <Card.Header className="fw-bold">
                Verify Your Information
            </Card.Header>

            <Alert variant="warning" className="m-3">
                <b>
                    <FontAwesomeIcon icon={faTriangleExclamation} className="me-2" />
                    Note:
                </b>{" "}
                If you find any issues in the below information, contact invigilator.
            </Alert>

            <Card.Body>

                {userInfo && userInfo.studentInfo.map((data: any) => (
                    <div
                        key={data?.registrationNumber}
                        className="d-flex justify-content-between align-items-start flex-wrap gap-4"
                    >

                        {/* LEFT SIDE INFO */}
                        <div style={{ fontSize: "1rem" }}>
                            <p>
                                <span>Name: </span>
                                <span className="fw-bold">
                                    {data?.name + " " + data?.last_name}
                                </span>
                            </p>

                            <p>
                                <span>Email: </span>
                                <span className="fw-bold">{data?.email}</span>
                            </p>

                            <p>
                                <span>Date of Birth: </span>
                                <span className="fw-bold">
                                    {createDateFormat(data?.dob)}
                                </span>
                            </p>

                            <p>
                                <span>Reg Number: </span>
                                <span className="fw-bold">
                                    {data?.registrationNumber || "---"}
                                </span>
                            </p>
                        </div>

                        {/* RIGHT SIDE IMAGE (LARGER) */}
                        <div
                            style={{
                                border: "1px solid #E5E7EB",
                                borderRadius: "12px",
                                padding: "10px",
                                background: "#F9FAFB"
                            }}
                        >
                            <Image
                                src={data?.image}
                                alt="Student"
                                rounded
                                fluid
                                style={{
                                    height: "150px",
                                    width: "150px",
                                    objectFit: "cover",
                                    borderRadius: "10px",
                                    boxShadow: "0 4px 12px rgba(0,0,0,0.08)"
                                }}
                            />
                        </div>

                    </div>
                ))}

                <div className="mt-4 text-end">
                    <Button
                        onClick={() => navigate("/exam/exam-dashboard")}
                        style={{
                            padding: "0.6rem 2rem",
                            fontWeight: 600,
                            borderRadius: "8px"
                        }}
                    >
                        Verify and Next
                    </Button>
                </div>

            </Card.Body>
        </Card>
    </>
);
}

export default StudentInfo